<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="col-md-12 mb-3">
                    <div class="form-group">
                        <label class="bmd-label-floating">Posting ke Forum</label>
                        <div class="input-group">
                            <textarea rows="2" class="form-control" placeholder="Posting ke Forum..." v-model="data.teks"></textarea>
                            <div v-show="!data.teksEmpty" class="input-group-append">
                                <button class="btn btn-sm btn-outline-danger" @click="data.teksEmpty = true,data.teks = ''" type="button">Cancel</button>
                            </div>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                        <div>
                        <input v-show="!data.teksEmpty" type="text" class="form-control" placeholder="Link..." v-model="data.link">
                        <input v-show="!data.teksEmpty" type="file" class="form-control file-upload" accept="image/*" @change="post.onFileChange" style="opacity:1;position:static">
                        <input type="hidden" class="form-control" placeholder="Nama..." v-model="post.datax.photoName"> 
                        <button v-show="!data.teksEmpty" class="btn btn-sm btn-primary" @click="post.submit()">Posting</button>
                        </div>
                        </transition>
                    </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="col-md-12 mb-3">
                    <h3 class="mt-0 text-right">List Postingan</h3>
                    <div class="postingan" v-for="(u, index) in theGet.data.List" @click="theGet.detail(u.data)">
                      <div class="header mb-1">
                        <div class="box-horizontal">
                          <div class="logo">
                            <div class="logo" :style="{ backgroundImage: 'url(' + u.data.icon + ')' }"></div>
                          </div>
                          <div class="nama">
                            <h5 class="mb-0 text-info">{{u.data.nama}}</h5>
                            <small class="text-secondary">{{u.data.jam}} - {{u.data.tanggal}}</small>
                          </div>
                        </div>
                      </div>
                      <div class="content">
                        <p v-html="myGlobal.newline(u.data.teks)"></p>
                        <img v-if="u.data.gambar != null" style="max-width:400px;max-height:200px" class="mb-2" :src="myGlobal.ForumAssets() + 'images/postingan/thumb_' + u.data.gambar" alt="gambar postingan">
                        <div class="d-block">
                          <div class="box-horizontal" style="margin-bottom:0">
                            <span class="mr-2 text-info">{{u.komen}}</span>
                            <span class="text-info">Komentar</span>
                          </div>
                        </div>
                      </div>
                    </div> 
                    <div class="loadmore text-center">
                      <button class="btn btn-sm btn-info" @click="theGet.loadmore()">Loadmore</button>
                    </div>
                </div>
              </div>
            </div>
          </div>
          
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { reactive, watch  } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import router from '@/router'

export default {
    components: { 
        'Loading': Loading
    }, 
    
  //methods: {
    setup() {
      const data = reactive({
        teks: '',
        link: '',
        teksEmpty: true,
        formd: '',
        page: 0,
        this: ''
      })
      watch(() => data.teks, (first, second) => {
        /*
        console.log(
            "Watch props.selected function called with args:",
            first,
            second
        );
        */

        if (first != "") {
            //console.log("ini tidak kosong");
            data.teksEmpty = false;
        } else {
            data.teksEmpty = true;
        }
      });

      const post = {
        datax: reactive({
          photo: "",
          photoName: null,
          lastid: ''
        }),
        onFileChange(e) {
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length)
              return;
              post.datax.photo = files[0];
        },
        upload() {
          let datau = new FormData();
          datau.append('image_file', this.datax.photo);

          var apiUrl = inter.ForumUpload()+"?token=TangTung "+sessionStorage.getItem('myToken')+"&ke=1&id="+this.datax.lastid;
          myGlobal.callForum(datau,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              if (x.status == true) {
                //this.data.List = x.data;

                data.teks = '';
                data.link = '';
                this.datax.photo = "";

                theGet.datae();
              } else {
                //alert(x.pesan);
              }
          })
        },
        submit() {
          //console.log(sessionStorage.getItem('admin'));
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              teks: data.teks.replace(/\n/g,'\\n'),
              link: data.link
          };
      
          var apiUrl = inter.ForumPost();
          myGlobal.callForum(datax,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              if (x.status == true) {
                this.datax.lastid = x.data;
                if (this.datax.photo != "") {
                  this.upload();
                } else {
                  data.teks = '';
                  data.link = '';
                  this.datax.photo = "";
                  
                  theGet.datae();
                }
                //this.data.List = x.data;
              } else {
                //alert(x.pesan);
              }
          })
        }
      }

      const theGet = {
        data: reactive({
          List: []
        }),
        datae() {
          //console.log(sessionStorage.getItem('admin'));
          var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            page: data.page
          };
      
          var apiUrl = inter.ForumList();
          myGlobal.callForum(datax,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              if (x.status == true) {
                this.data.List = x.data;
              } else {
                //alert(x.pesan);
              }
          })
        },
        loadmore() {
          data.page = data.page + 1;

          //console.log(sessionStorage.getItem('admin'));
          var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            page: data.page
          };
      
          var apiUrl = inter.ForumList();
          myGlobal.callForum(datax,apiUrl).then(x => {
              if (x.status == true) {

                var arr = x.data;
                for (var i = 0; i < arr.length; i++) {
                  console.log(arr[i]);
                  this.data.List.push(arr[i]);
                }

              } else {
                //alert(x.pesan);
              }
          })
        },
        detail(data) {
          router.push({ 
              name: 'forum-detail',
              params: data
          });
        }
      }
      
      return {
        data,
        post,
        theGet,
        myGlobal
      }

    },
    mounted () {
      document.title = "Forum";

      this.theGet.datae();
        
      this.formd = new FormData();
      this.formd.append('ke', '1');

      console.log(JSON.stringify(this.formd));

      this.data.this = this;
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.logo {
  height:50px;width:50px;
  background-size: auto 100% ;
  border-radius: 100%;
  margin-right: 20px;
  border: 1px solid #aeaeae;
}
.postingan {
  border-bottom: 1px solid #aeaeae;
  display: block;
  margin-bottom: 10px;
  padding: 10px;
}
.postingan:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/forum/main.vue